import { httpV2 } from "@/api";

/**
 * Solicita o conjunto de sensores com defeito referente ao ativo monitorado.
 * @param {Number} monitoringElementId Id do parque.
 * @returns Dados dos sensores defeituosos.
 */
const GetFailedSensors = function(monitoringElementId)
{
	return httpV2.get(`/WindPark/${monitoringElementId}/FailedSensors`);
};

export default
{ GetFailedSensors };